import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const Loading = () => {
  return <CircularProgress data-testid="Loading" />;
};

export default Loading;
